/* eslint-disable */
var router;

const SearchRouter = function() {
	var self = this,
		bcbRouter = Backbone.Router.extend({
			routes: {
				"?" :  "default",
				"?(!)*params": "search",
				  "*path" :  "default"
			},
			initialize: function() {
				setTimeout(function() {
					Backbone.history.start();
				},1);
			},
			go:function(url, params) {
				if(document.location.hash == "") {
					params = $.extend({}, (params ? params : {}), {
						replace:true
					});
				}
				if(params && params.newTab) {
					window.open(url, '_blank');
				} else {
					if(url.indexOf('#') == -1) {
						this.navigate(url, params);
					} else {
						document.location.href = url;
					}
				}
			}
		});
	
	self.getInstance = function() {
		router = router ? router : new bcbRouter();
		return router;
	}
};

export default SearchRouter;